/**
 * query url params
 */
export const queryString = (key: string) => {
  console.log(window.location)
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(key)
}

export const getUrlKey = (name: string) => {
  if (!name) {
    return null
  }
  const regexp = new RegExp(`[?|&]${name}=` + `([^&;]+?)(&|#|;|$)`)
  const match = regexp.exec(window.location.href)
  if (match) {
    return decodeURIComponent(match[1].replace(/\+/g, '%20'))
  }

  return null
}

/**
 * fake sleep
 */
export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export const noop = () => {
  // nothing
}

/**
 * load script
 */
export const loadScript = (url: string, callback = noop) => {
  const { head, createElement } = document
  const script = createElement('script')
  script.onload = callback
  script.src = url

  head.appendChild(script)
}

// padding zero
export const paddingZero = (digital: number) => {
  return digital > 9 ? `${digital}` : `0${digital}`
}

export const copyToClipboard = (str: string) => {
  const el = document.createElement('textarea')
  el.value = str
  el.setAttribute('readonly', '')
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// `wait` milliseconds.
export const debounce = (func: Function, wait: number) => {
  let timeout: undefined | number

  // This is the function that is returned and will be executed many times
  // We spread (...args) to capture any number of parameters we want to pass
  return function executedFunction(...args: any) {
    // The callback function to be executed after
    // the debounce time has elapsed
    const later = () => {
      // null timeout to indicate the debounce ended
      timeout = undefined

      // Execute the callback
      func(...args)
    }
    // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the
    // inside of the previous setTimeout
    clearTimeout(timeout)

    // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs Node)
    timeout = setTimeout(later, wait)
  }
}

export const truncate = (str: string, size: number, tail: string) => {
  function isEmpty(str: string | undefined | null) {
    if (str === undefined || str === '' || str === null) {
      return true
    }
    return false
  }
  function trim(str: string) {
    if (isEmpty(str)) {
      return ''
    }
    return str.replace(/(^\s*)|(\s*$)/g, '')
  }

  function charLength(str: string) {
    const nstr = str.replace(/[^x00-xff]/g, 'JJ')

    return nstr.length
  }

  let nstr = trim(str)
  const cLen = charLength(nstr)
  const length = size <= 0 ? cLen : size
  if (length >= cLen) return nstr
  while (charLength(nstr) > length) {
    nstr = nstr.substr(0, nstr.length - 1)
  }
  nstr += tail || '...'

  return nstr
}

/** Used to map characters to HTML entities. */
const htmlEscapes: any = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}

/** Used to match HTML entities and HTML characters. */
const reUnescapedHtml = /[&<>"']/g
const reHasUnescapedHtml = RegExp(reUnescapedHtml.source)

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @since 0.1.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @see escapeRegExp, unescape
 * @example
 *
 * escape('fred, barney, & pebbles')
 * // => 'fred, barney, &amp; pebbles'
 */
export function escape(string: string) {
  return string && reHasUnescapedHtml.test(string)
    ? string.replace(reUnescapedHtml, chr => htmlEscapes[chr])
    : string || ''
}
